/* paginate doctors list */
let url = window.location.href;
let pathname = new URL(url).pathname;
// Split the pathname using '/' as the separator
let pathParts = pathname.split("/");

// Get the part you are interested in (assuming it's always the second part)
let desiredPart = pathParts[2];
let parts = pathname.split("/");
let cityName = parts[parts.length - 1];
const urlParams = new URLSearchParams(window.location.search);
const page = urlParams.get("page");
function doctors_list(pageNumber) {
  let apiurl;
  if (pathname.includes("hair-transplant")) {
    apiurl = `https://public-jgfas325.hav-g.in/getdoctors/${cityName}?type=transplant-doctors&pageNumber=${pageNumber}&pageSize=10`;
  } else if (pathname.includes("hair-doctors")) {
    apiurl = `https://public-jgfas325.hav-g.in/doctors/${cityName}?pageNumber=${pageNumber}&pageSize=10`;
  } else {
    apiurl = `https://public-jgfas325.hav-g.in/getdoctors/${cityName}?type=dermatologists&pageNumber=${pageNumber}&pageSize=10`;
  }
  fetch(apiurl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      var scriptElement = document.createElement("script");
      scriptElement.setAttribute("defer", "");
      scriptElement.setAttribute("type", "application/ld+json");
      const jsonStrings = [];
      data.doctorRecords.forEach((doctor, index) => {
        const schema = {
          "@context": "http://schema.org/",
          "@type": doctor.doctor_profile,
          name: doctor.doctor_name,
          medicalSpecialty: doctor.specialities_detail.split("|"),
          address: {
            "@type": "PostalAddress",
            addressLocality: doctor.city_name,
            streetAddress: doctor.address_details,
          },
          priceRange: doctor.doctor_fee,
          currenciesAccepted: "INR",
        };
        jsonStrings.push(JSON.stringify(schema));
      });
      const combinedJson = `${jsonStrings.join(",\n")}`;
      scriptElement.appendChild(document.createTextNode(combinedJson));
      document.head.appendChild(scriptElement);
      let hair_doc_loader = document.querySelector("#hair_doc_loader");
      hair_doc_loader.style.display = "none";
      if (data.doctorRecords.length == 0) {
         observer.unobserve(document.getElementById("hair_doc_loading_animation"));
        let hair_doc_loader = document.querySelector("#hair_doc_loader");
        if (hair_doc_loader) hair_doc_loader.style.display = "none";
        return;
      }
      let doc_list = document.querySelector("#list");
      if (doc_list) {
        document.querySelector(
          ".doctors-list-heading"
        ).innerHTML = `${data.H1}`;
      }
      let doctor_data = document.querySelector("#doctor_data");
      let pagiNation = document.querySelector(".list");
      let image_section = document.querySelector(".image_section");
      data.doctorRecords.forEach((doc_data, index) => {
        index = index + 1;
        let HTML = `
       <div class="doctor_deatils_main" index=${index}>
         <div class="doc_details_top">
           <div class="doc_detail_left">
             <h3 class="doc_name mb-0"><strong>${doc_data.doctor_name}</strong></h3>
             <p class="doc_profile">${doc_data.doctor_profile}</p>
             <p class="doc_exp">${doc_data.doctor_experiences}</p>
             <p class="doc_fee">Consultation Fee: ${doc_data.doctor_fee}</p>
           </div>
           <div class="doc_detail_right">
               <b><p class="doc_add">Address:</p></b>
               <p class="doc_add_details">${doc_data.address_details}</p>
           </div>
         </div>
         <div class="doc_details_bottom">
           <b><p class="education sep">Education:</p></b>
             <span class="normal sep_detail education_detail sep_detail_truncate">${doc_data.education_detail}</span><span class="dl-see-more">+see more</span> 
         </div>
       </div>
       `;
        let parsedHTML = new DOMParser()
          .parseFromString(HTML, "text/html")
          ?.querySelector(".doctor_deatils_main");
        if (doctor_data) {
          doctor_data.append(parsedHTML);
        }
      });
      let total_count = data.totalDoctorCount;
      let page_10 = total_count / 10;
      let totalPage = Math.ceil(page_10, "page_10");
      let last = totalPage - pageNumber;
      let paginationBTN_wrapper;
      let start, end;

      pageNumber = parseInt(pageNumber);
      if (totalPage <= 3) {
        start = 1;
        end = totalPage;
      } else if (pageNumber >= 3 && last != 0) {
        start = pageNumber - 1;
        end = pageNumber + 1;
      } else if (last == 0) {
        start = pageNumber - 2;
        end = pageNumber;
      } else {
        start = 1;
        end = 3;
      }
    
      let image_html1 = `
    <div style="padding-top:1px; padding-bottom:1px;">
      <div class="blog-banner-one banner-2">
        <div class="blog-content">
          <div class="heading_banner">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" id="hdcard1">
              <h1>Hair analysis by Doctors</h1>
            </a>
          </div>
          <div class="paragraph_banner paragraph_desktop">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" id="hdcard1">
              <p class="de_content"> Get doctor recommended plans from the comfort of your home with Traya.</p>
            </a>
          </div>
          <div class="paragraph_banner pargraph_mobile">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" id="hdcard1">
              <p class="de_content">Get doctor recommended plans from the comfort of your home with Traya.</p>
            </a>
          </div>
          <div class="banner_one_btn">
          <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" class="btn hair-doctor-shimmer" id="hdcard1">
            TAKE THE HAIR TEST <sup>TM<sup>
          </a>
          </div>
        </div>
        <div class="blog-images">
          <a  href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" id="hdcard1">
            <img
              src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/desktop_image_700x_1.png?v=1722443857"
              alt="Desktop Image"
              class="desktop-image"
              width=""
              height="">
          </a>
          <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card1" id="hdcard1" style="background: white">
            <img
              src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/desktop_image_700x_1.png?v=1722443857"
              alt="Mobile Image"
              class="mobile-image"
              width="100%"
              height="">
          </a>
        </div>
      </div>
    </div>
        `;
      let image_html2 = `
         <div style="padding-top:1px; padding-bottom:1px;">
      <div class="blog-banner-one banner-1">
        <div class="blog-content">
          <div class="heading_banner">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card2&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" id="hdcard2">
              <h1>Are you facing hair loss?</h1>
            </a>
          </div>
          <div class="paragraph_banner paragraph_desktop">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card1&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" id="hdcard2">
              <p class="de_content">Are you facing Hair loss? Find the root cause by taking <br> Doctor-certified Hair Test.</p>
            </a>
          </div>
          <div class="paragraph_banner pargraph_mobile">
            <a href="https://form.traya.health/questions?cohort=1&amp;location=card2&amp;page=${window.location.pathname
              .substring(1)
              .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" id="hdcard2">
              <p class="de_content"> Are you facing Hair loss? <br> Find the root cause by taking <br> Doctor-certified Hair Test.</p>
            </a>
          </div>
          <div class="banner_one_btn">
          <a href="https://form.traya.health/questions?cohort=1&amp;location=card2&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" class="btn hair-doctor-shimmer" id="hdcard2">
            TAKE THE HAIR TEST <sup>TM<sup>
          </a>
          </div>
        </div>
        <div class="blog-images">
          <a  href="https://form.traya.health/questions?cohort=1&amp;location=card2&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" id="hdcard2">
            <img
              src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/card1-desktop-img.png?v=1721993518"
              alt="Desktop Image"
              class="desktop-image"
              width="100"
              height="100"
              loading="lazy">
          </a>
          <a  href="https://form.traya.health/questions?cohort=1&amp;location=card2&amp;page=${window.location.pathname
            .substring(1)
            .replaceAll("/", "_")}&utm_campaign=blogs_hd_card2" id="hdcard2" style="background: white">
            <img
              src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/card1-mobile-img.png?v=1721993517"
              alt="Mobile Image"
              class="mobile-image"
              width="100"
              height="100"
              loading="lazy">
          </a>
        </div>
      </div>
    </div>`;
      // Remove previous banners
      document.querySelectorAll(".dynamic-banner").forEach(banner => banner.remove());
      
      const doctorElements = document.querySelectorAll(".doctor_deatils_main");
      for (let i = 0; i < doctorElements.length; i++) {
        if ((i + 1) % 4 === 0) {
          const imageToInsert = (i + 1) % 8 === 0 ? image_html2 : image_html1;
          // Wrap imageToInsert with a div having class 'dynamic-banner'
          const wrappedBanner = `<div class="dynamic-banner">${imageToInsert}</div>`;
          doctorElements[i].insertAdjacentHTML("afterend", wrappedBanner);
        }
      }

      let banner_text = document.querySelectorAll(".banner_text");
      banner_text.forEach((item) => {
        let tgtseptext = item.textContent;
        item.innerHTML = tgtseptext.replace(/%s/g, `${total_count}`);
      });
    })
    .catch((error) => {
      console.log("Fetch error:", error);
    })
    .finally(() => {
      doctorsActions();
    });
  function doctorsActions() {
    let tgtsep = document.querySelectorAll(".sep_spacialisties");
    tgtsep.forEach((item) => {
      let tgtseptext = item.textContent;
      item.innerHTML = tgtseptext.replace(/:::/g, " | ");
    });
    let tgtEdu = document.querySelectorAll(".education_detail");
    tgtEdu.forEach((item) => {
      let tgtEduText = item.innerHTML;
      let modifiedText = tgtEduText.replace(/:::/g, "<br>").replace(/:::/g, "");
      item.innerHTML = modifiedText;
    });
    $(".dl-see-more").click(function () {
      $(this)
        .parent()
        .find(".education_detail")
        .removeClass("sep_detail_truncate");
      $(this).hide();
    });
  }
}
const page_no = page || 1;
doctors_list(page_no);
/* end paginate doctors list */

let pageNumber = 2;
let isFetching = false;

// Observer callback
function handleIntersect(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting && !isFetching) {
      isFetching = true;
      doctors_list(pageNumber);
      pageNumber++;
      setTimeout(() => {
        isFetching = false;
      }, 2000);
    }
  });
}

// Target element
const target = document.getElementById('hair_doc_loading_animation');

if (target) {
  const observer = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  });
  observer.observe(target);
} else {
  console.warn("#hair_doc_loading_animation not found in the DOM");
}

/* faq hair doctors */
let loadMore = document.querySelector(".loadMore");
let showMore = parseInt(
  document.querySelector(".faq-hair-doctors")?.getAttribute("show_faq")
);
let load_faq = document.querySelectorAll(".accordion-item");
let less;
if (loadMore) {
  loadMore.addEventListener("click", function () {
    less = loadMore.classList.contains("less");
    if (less) {
      loadMore.classList.remove("less");
      loadMore.innerText = "Show more";
      load_faq.forEach(function (faq, i) {
        if (showMore <= i) {
          faq.classList.add("hide");
        }
      });
    } else {
      loadMore.classList.add("less");
      loadMore.innerText = "Show less";
      load_faq.forEach(function (faq) {
        faq.classList.remove("hide");
      });
    }
  });
}
/* end faq hair doctors */
document.querySelectorAll("#hdcard1, #hdcard2").forEach((item) => {
        item.addEventListener('click', function () {
            let tgtcstData = JSON.parse(localStorage.getItem("CstData"));
            if (tgtcstData) {
                let hashEmail = md5(tgtcstData.user.email);
                let hashMobile = md5(tgtcstData.user.phone_number.toString());
                gtag('event', 'HairTest_Started_Blog', {
                    "EID": hashEmail,
                    "MID": hashMobile,
                     "NAEID": tgtcstData.user.email,
                    "NAMID": tgtcstData.user.phone_number,
                    "Gender": tgtcstData.user.gender,
                    "Section": "Top Navigation",
                    "userStatus": "Loggedin",
                    'send_to': 'G-KJK84KP0LJ',
                    "Time": formattedTime
                });
            }
            else {
                gtag('event', 'HairTest_Started_Blog', {
                    'send_to': 'G-KJK84KP0LJ',
                    "Time": formattedTime
                });
            }

        })
    })

/* you may like */
if ($(".may_you_like").length > 0) {
  $(".may_you_like").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    centerPadding: "40px",
    arrows: false,
    responsive: [
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
/* end you may like */
